import React, { useState, useEffect } from "react"
import _ from "lodash"

import NoneStateTrashIcon from "components/table/carousel/none-state-trash-icon"
import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { CheckboxInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const VacancyLossBasic = (props: {rowData: [], field: string, namedItems: {}, persist: Function}) => {
  const emptyRecord = {
    percent: null,
    reducePercentByVacancy: null
  }
  const [data, setData] = useState<object|null>(props.rowData[props.field]);

  useEffect(() => {
    if (!_.get(props, `rowData.${props.field}`) || _.get(props, `rowData.${props.field}.state`) !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    // default checkbox to false if nothing is set
    if(!_.get(nextData, "reducePercentByVacancy") && field !== "reducePercentByVacancy") {
      nextData["reducePercentByVacancy"] = false
    }

    nextData[field] = val
    setData(nextData);
    props.persist({...nextData, state: 'basic'}, 'vacancylossdetail', props.rowData)
  }

  const attrs = (field) => field_attrs('multifamily', props.field)(field)(props.rowData, props)

  return (
    <div>
      <NoneStateTrashIcon />
      <SingleRowCarouselState_s>
        <div>
          <label>Percent</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="percent" readPrecision={2} writePrecision={2} persist={updateData} />
        </div>
        <div>
          <label>Reduce % by Vacancy</label>
          <CheckboxInput className="automated" data={data!} field="reducePercentByVacancy" persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default VacancyLossBasic